import { Injectable } from '@angular/core';
// tslint:disable-next-line: max-line-length
import { AppointmentClearCode, ClearCodeOption, TicketClearCodeAllowed, TicketClearCodeOptions, TicketClearCodeTypes } from 'src/app/core/models/ticket-clear-code-type.model';
import { LocalStorageService } from 'src/app/core/storage/local-storage/local-storage.service';

@Injectable({
	providedIn: 'root'
})
export class ClearCodeService {

	constructor(
		private storage: LocalStorageService,
	) { }

	async getTicketClearCodeOptions(clearCodeTicketId: number): Promise<ClearCodeOption[]> {
		const tccOptions = await this.storage.ticketClearCodeOptions.getItem<TicketClearCodeOptions>(`${clearCodeTicketId}`);
		if (!tccOptions) {
			throw new Error('Error loading Clear Code Options');
		}

		return tccOptions.options;
	}

	async getAllowedClearCodeIds(ticketCodeId: number): Promise<number[]> {
		const tccAllowed = await this.storage.ticketClearCodeAllowed.getItem<TicketClearCodeAllowed>(`${ticketCodeId}`);
		if (!tccAllowed) {
			throw new Error('Error loading Clear Code Allowed Options');
		}

		return tccAllowed.allowed;
	}

	async getTicketClearCodeTypes(ticketCodeId: number): Promise<TicketClearCodeTypes> {
		return await this.storage.ticketClearCodeTypes.getItem<TicketClearCodeTypes>(`${ticketCodeId}`);
	}

	async getAppointmentClearCode(appointmentId: number): Promise<AppointmentClearCode> {
		return await this.storage.appointmentClearCode.getItem<AppointmentClearCode>(`${appointmentId}`);
	}

	async clearTable(): Promise<void> {
		this.storage.appointmentClearCode.clear();
	}
}
